<script>
  import ValidationMessage from '../../../../components/form/ValidationMessage.vue'
  import Password from 'vue-password-strength-meter'
  import * as restfulService from '../../../../services/restfulService'
  import * as notifyService from '../../../../services/notifyService'
  import * as cepService from '../../../../services/cepService'
  import helperMixin from '../../../../../mixins/helper'
  import {required, requiredIf, email} from 'vuelidate/lib/validators'
  import {cloneDeep} from 'lodash'
  import bus from '@utils/bus'

  export default {
    components: {ValidationMessage, Password},
    mixins: [helperMixin],
    props: ['registration'],
    data () {
      return {
        isLoadingData: true,
        isSubmitted: false,
        isSearchingCity: false,
        data: {
          ref_pessoa: '',
          ref_cidade: '',
          nome: '',
          cep: '',
          rua: '',
          numero: '',
          complemento: '',
          bairro: '',
          email: '',
          email_alternativo: '',
          senha: '',
          senha_confirmacao: ''
        },
        dependencies: {
          cities: []
        }
      }
    },
    validations: {
      data: {
        nome: {required},
        email: {required, email},
        email_confirmacao: {
          required: requiredIf(function () {
            return this.data.email
          })
        },
        email_alternativo: {email},
        cep: {required},
        rua: {required},
        numero: {required},
        bairro: {required},
        ref_cidade: {required},
        senha: {
          required: requiredIf(function () {
            return !this.data.ref_pessoa
          })
        },
        senha_confirmacao: {
          required: requiredIf(function () {
            return this.data.senha
          })
        }
      }
    },
    mounted () {
      if (!this.registration) {
        this.$swal({
          title: 'Atenção',
          text: 'Você não pode acessar essa página diretamente',
          type: 'warning'
        })
        this.$router.push({name: 'registration.index'})
      } else {
        // Recupera os dados da props: registration e atribui ao data do componente
        this.data = this.registration.personalData.data
        this.isLoadingData = false
      }
    },
    watch: {
      /**
       * Observa alterações no CEP para autocompletar os dados do endereço pela API do viacep
       */
      'data.cep': function () {
        if (this.data.cep) {
          let cep = this.onlyNumbers(this.data.cep)
          if (cep.length === 8) {
            bus.$emit('show-loader')
            cepService.get(cep)
              .then(data => {
                if (!data.hasOwnProperty('erro')) {
                  this.data.rua = data.logradouro
                  this.data.bairro = data.bairro
                  this.onSearchCity(data.localidade).then(_ => {
                    this.data.ref_cidade = this.dependencies.cities[0].id
                    if (!this.data.numero) {
                      this.$refs.personalDataNumero.focus()
                    }
                    bus.$emit('hide-loader')
                  })
                }
              })
              .catch(() => {
                notifyService.warning({title: 'Atenção', message: 'Endereço não encontrado, verifique o CEP'})
                bus.$emit('hide-loader')
                console.log('error')
              })
          }
        }
      }
    },
    methods: {
      /**
       * Busca cidades na API/Segue
       * @param query
       * @returns {Promise<any>}
       */
      onSearchCity (query) {
        return new Promise((resolve, reject) => {
          this.dependencies.cities.splice(0)
          if (query !== '') {
            this.isSearchingCity = true
            let data = {
              query
            }
            restfulService.post('city', 'search', null, data)
              .then((response) => {
                this.dependencies.cities.splice(0)
                this.dependencies.cities = [...this.dependencies.cities, ...response]
                this.isSearchingCity = false
                resolve()
              })
              .catch(e => {
                console.log(e)
                reject()
              })
          }
        })
      },
      /**
       * Avança uma etapa na inscrição
       * Passa os dados preenchidos via props para serem recuperados na etapa
       */
      onSaveData () {
        let data = cloneDeep(this.registration)
        data.personalData.data = cloneDeep(this.data)
        this.$router.push({name: 'registration.store.physical', params: {registration: data}})
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData">
        <div class="forms form-registration">
            <el-form :model="data"
                     label-position="top">
                <h3 class="title-separator">Seus dados</h3>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Nome"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.data.nome.$error }">
                            <el-input v-model="data.nome"
                                      @input="$v.data.nome.$touch()"/>
                            <validation-message v-if="$v.data.nome.$error"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="CEP"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.data.cep.$error }">
                            <el-input v-model="data.cep"
                                      @input="$v.data.cep.$touch()"
                                      key="personalDataCep"
                                      v-mask="'#####-###'"/>
                            <validation-message v-if="$v.data.cep.$error"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Rua"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.data.rua.$error }">
                            <el-input v-model="data.rua"
                                      @input="$v.data.rua.$touch()"/>
                            <validation-message
                                    v-if="$v.data.rua.$error"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Número"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.data.numero.$error }">
                            <el-input v-model="data.numero"
                                      ref="personalDataNumero"
                                      @input="$v.data.numero.$touch()"/>
                            <validation-message
                                    v-if="$v.data.numero.$error"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Bairro"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.data.bairro.$error }">
                            <el-input v-model="data.bairro"
                                      @input="$v.data.bairro.$touch()"/>
                            <validation-message
                                    v-if="$v.data.bairro.$error"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Complemento">
                            <el-input v-model="data.complemento"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="Cidade"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.data.ref_cidade.$error }">
                    <el-select v-model="data.ref_cidade"
                               clearable
                               filterable
                               remote
                               :remote-method="onSearchCity"
                               :loading="isSearchingCity"
                               placeholder="Digite o nome da cidade"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full"
                               @input="$v.data.ref_cidade.$touch()">
                        <el-option
                                v-for="item in dependencies.cities"
                                :key="item.id"
                                :label="item.name + ' / ' + item.state.uf"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <validation-message v-if="$v.data.ref_cidade.$error"/>
                </el-form-item>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="Email"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.data.email.$error }">
                            <el-input v-model="data.email"
                                      @input="$v.data.email.$touch()"/>
                            <validation-message v-if="$v.data.email.$error"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Confirme seu Email"
                                      class="is-required"
                                      v-bind:class="{ 'el-form-item--error': $v.data.email_confirmacao.$error }">
                            <el-input v-model="data.email_confirmacao"
                                      @input="$v.data.email_confirmacao.$touch()"/>
                            <validation-message
                                    v-if="$v.data.email_confirmacao.$error"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Email Alternativo"
                                      v-bind:class="{ 'el-form-item--error': $v.data.email_alternativo.$invalid }">
                            <el-input v-model="data.email_alternativo"
                                      @input="$v.data.email_alternativo.$touch()"/>
                            <validation-message v-if="$v.data.email_alternativo.$invalid"
                                                message="Preencha esse campo com um email válido"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" v-if="!data.ref_pessoa">
                    <el-col :span="12">
                        <el-form-item label="Senha"
                                      v-bind:class="{ 'el-form-item--error': $v.data.senha.$error, 'is-required': $v.data.senha.required && $v.data.senha.$invalid }">
                            <password v-model="data.senha"
                                      default-class="password-strength"
                                      :secure-length="6"
                                      :required="true"
                                      placeholder="Digite a senha"
                                      @input="$v.data.senha.$touch()"/>
                            <validation-message v-if="$v.data.senha.$error"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Confirmação de Senha"
                                      v-bind:class="{ 'el-form-item--error': $v.data.senha_confirmacao.$error, 'is-required': $v.data.senha_confirmacao.required && $v.data.senha_confirmacao.$invalid }">
                            <el-input v-model="data.senha_confirmacao"
                                      type="password"
                                      @input="$v.data.senha_confirmacao.$touch()"/>
                            <validation-message
                                    v-if="$v.data.senha_confirmacao.$error"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item class="buttons-save">
                    <el-button type="primary"
                               size="large"
                               @click="onSaveData"
                               :disabled="isSubmitted || $v.data.$invalid">
                        <i class="fa fa-arrow-right"></i>
                        <span>Salvar e Avançar</span>
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<style lang="scss">
    .Password {
        float: left;
        width: 400px;

        .password-strength {
            -webkit-appearance: none;
            background-color: #fff;
            background-image: none;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
            box-sizing: border-box;
            color: #606266;
            display: inline-block;
            font-size: inherit;
            height: 40px;
            line-height: 40px;
            outline: none;
            padding: 0 15px;
            transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
            width: 100%;
        }
    }
</style>
